import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TwitterIcon from "@material-ui/icons/Twitter";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import Link from "../Link";
import { useStaticQuery, graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import RobFamilyLogo from "../../images/rob-family-logo-no-text.png";
import Grid from "@material-ui/core/Grid/Grid";
import ReactHtmlParser from "react-html-parser";
import BackToTop from "react-back-to-top-button";
import FooterAltNav from "../FooterAltNav";
import styles from "./styles";
import { expandSettings } from "../../app/action";
import { connect } from "react-redux";

const useStyles = makeStyles(theme => styles(theme));

const mapDispatchToProps = dispatch => ({
  expandSettings: () => dispatch(expandSettings()),
});

const mapStateToProps = state => ({
  saved: state.cookiesSettings.saved,
});

function Footer(props) {
  const classes = useStyles();

  const [infoOpen, setInfoOpen] = React.useState(true);
  const [aboutOpen, setAboutOpen] = React.useState(false);
  const [socialOpen, setSocialoOpen] = React.useState(false);
  const handleInfoOpen = () => {
    setInfoOpen(!infoOpen);
  };
  const handleAboutOpen = () => {
    setAboutOpen(!aboutOpen);
  };
  const handleSocialOpen = () => {
    setSocialoOpen(!socialOpen);
  };

  function openCookieSettings() {
    props.expandSettings();
  }

  const data = useStaticQuery(graphql`query FooterItems {
    allWpMenu(filter: {locations: {eq: FOOTER_MENU}}) {
      nodes {
        id
        name
        slug
        menuItems {
          nodes {
            id
            title
            url
            path
            label
            target
            order
            childItems {
              nodes {
                id
                title
                url
                path
                label
                target
                order
              }
            }
          }
        }
      }
    }
    allWp {
      nodes {
        themeOptions {
          ThemeOptions {
            footerLogo {
              localFile {
                id
                publicURL
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            individualInnsBranding
          }
        }
        locationData {
          LocationData {
            address1
            address2
            email
            facebookHandle
            instagramHandle
            name
            postcode
            town
            twitterHandle
            telephone
            region
          }
        }
      }
    }
  }
  `);

  const currentYear = new Date().getFullYear();
  return (
    <div
      className={`footer ${
        data.allWp.nodes[0].themeOptions.ThemeOptions.individualInnsBranding === true
          ? "indi-inns"
          : ""
      } ${classes.footer}  ${classes.footerTheme}`}
    >
      <Grid
        container
        spacing={3}
        direction="row"
        alignItems="flex-start"
        style={{ margin: 0, width: "100%" }}
      >
        <Grid item xs={12}>
          <BackToTop showAt={1} speed={1500} easing="easeInOutQuint">
            <span>Top</span>
          </BackToTop>
        </Grid>
        <Grid item xs={12} md={3} lg={6}>
          <div className="site-logo">
            <img
              src={RobFamilyLogo}
              alt="A part of the Robinsons Brewery Family"
              width={136}
              height={139}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={3} lg={2}>
          <p
            className="footer-h"
            role="presentation"
            onClick={() => handleInfoOpen()}
            onKeyDown={() => handleInfoOpen()}
            data-open={infoOpen}
          >
            Information
          </p>
          <div
            className="information footer-nav footer-expand"
            data-open={infoOpen}
          >
            {data.allWpMenu.nodes[0].menuItems.nodes.map(section => (
              <Link key={section.path} to={section.path}>
                {ReactHtmlParser(section.label)}
              </Link>
            ))}
            <button onClick={e => openCookieSettings()}>Cookie control</button>
          </div>
        </Grid>
        <Grid item xs={12} md={3} lg={2}>
          <p
            className="footer-h"
            role="presentation"
            onClick={() => handleAboutOpen()}
            onKeyDown={() => handleAboutOpen()}
            data-open={aboutOpen}
          >
            About Us
          </p>
          <div
            className="about-us footer-nav footer-expand"
            data-open={aboutOpen}
          >
            <FooterAltNav />
          </div>
        </Grid>
        <Grid item xs={12} md={3} lg={2}>
          <p
            className="footer-h"
            role="presentation"
            onClick={() => handleSocialOpen()}
            onKeyDown={() => handleSocialOpen()}
            data-open={socialOpen}
          >
            Social
          </p>
          <div className="social-links footer-expand" data-open={socialOpen}>
            {data.allWp.nodes[0].locationData.LocationData.instagramHandle !== null && (
              <Link
                to={
                  "https://www.instagram.com/" +
                  data.allWp.nodes[0].locationData.LocationData.instagramHandle
                }
              >
                <InstagramIcon /> <span>Follow us</span>
              </Link>
            )}
            {data.allWp.nodes[0].locationData.LocationData.twitterHandle !== null && (
              <Link
                to={
                  "https://www.twitter.com/" +
                  data.allWp.nodes[0].locationData.LocationData.twitterHandle
                }
              >
                <TwitterIcon /> <span>Follow us</span>
              </Link>
            )}
            {data.allWp.nodes[0].locationData.LocationData.facebookHandle !== null && (
              <Link
                to={
                  "https://www.facebook.com/" +
                  data.allWp.nodes[0].locationData.LocationData.facebookHandle
                }
              >
                <FacebookIcon /> <span>Like us</span>
              </Link>
            )}
            <Link
              to={
                "https://www.linkedin.com/company/robinsons-brewery/"
              }
            >
              <LinkedInIcon /> <span>Follow us</span>
            </Link>
            <Link to={"https://www.tiktok.com/@robinsonsbrewery"}>
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 448 512"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"></path>
              </svg>{" "}
              <span>Follow us</span>
            </Link>
          </div>
        </Grid>
        <Grid item xs={12} md={6} className="drink-aware">
          <Link to="https://www.drinkaware.co.uk">
            <StaticImage
              src="../../images/drinkaware.png"
              alt="For further health information, visit drinkaware.co.uk"
            />
          </Link>
        </Grid>
        <Grid item xs={12} md={6} className="credits">
          <p>
            <span>&copy;</span> Frederic Robinson Limited {currentYear}. All
            Rights Reserved
          </p>
        </Grid>
      </Grid>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
